import { render } from "./FacturacionNueva.vue?vue&type=template&id=c7d42a7c"
import script from "./FacturacionNueva.vue?vue&type=script&lang=js"
export * from "./FacturacionNueva.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__